// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/icon/transactions-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/icon/logo-eth.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/icon/sort-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transactions-page {
  padding: 24px;
  background-color: #f9fafb;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.title-icon.transactions {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.eth-icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.summary-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-cards {
  display: flex;
  gap: 32px;
}

.summary-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.summary-card .card-title {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

.summary-card .card-value {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 6px;
}

.eth-icon {
  font-size: 14px;
  color: #627eea;
}

.currency-icon {
  font-size: 12px;
  color: #6b7280;
}

.green-text {
  color: #86efac;
}

.summary-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}


.detail-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.table th {
  background-color: #f9fafb;
  font-weight: 600;
  color: #374151;
  padding: 12px 8px;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}

.table td {
  padding: 12px 8px;
  border-bottom: 1px solid #e5e7eb;
  color: #111827;
}

.table tr:hover {
  background-color: #f9fafb;
}

.sort-icon {
  width: 10px;
  height: 10px;
  margin-left: 4px;
  cursor: pointer;
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.type-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.type-badge.buy {
  background-color: #dcfce7;
  color: #166534;
}

.type-badge.sell {
  background-color: #fee2e2;
  color: #991b1b;
}

.address-cell {
  display: flex;
  align-items: center;
  gap: 4px;
}

.copy-icon {
  font-size: 12px;
  color: #6b7280;
  cursor: pointer;
}

.copy-icon:hover {
  color: #374151;
}

.txn-link {
  color: #3b82f6;
  text-decoration: none;
  font-size: 14px;
}

.txn-link:hover {
  color: #1d4ed8;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.pagination-info {
  color: #6b7280;
  font-size: 14px;
}

.pagination-controls {
  display: flex;
  gap: 4px;
  align-items: center;
}

.pagination-btn {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  min-width: 40px;
}

.pagination-btn:hover:not(:disabled) {
  background-color: #f3f4f6;
}

.pagination-btn.active {
  background-color: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-ellipsis {
  padding: 8px 4px;
  color: #6b7280;
  font-size: 14px;
}

/* Responsive design */
@media (max-width: 768px) {
  .transactions-page {
    padding: 16px;
  }
  
  .summary-section {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .summary-cards {
    justify-content: space-around;
    gap: 16px;
  }
  
  .summary-controls {
    justify-content: center;
  }
  
  .detail-section {
    padding: 16px;
  }
  
  .table {
    font-size: 12px;
  }
  
  .table th,
  .table td {
    padding: 8px 4px;
  }
  
  .pagination {
    flex-direction: column;
    gap: 12px;
  }
  
  .pagination-controls {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 1024px) {
  .summary-cards {
    gap: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Transactions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yDAAgE;AAClE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yDAAuD;EACvD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yDAAwD;EACxD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":[".transactions-page {\n  padding: 24px;\n  background-color: #f9fafb;\n  min-height: 100vh;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #111827;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.title-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.title-icon.transactions {\n  background-image: url('../../public/icon/transactions-icon.png');\n}\n\n.eth-icon {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  background-image: url('../../public/icon/logo-eth.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.summary-section {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.summary-cards {\n  display: flex;\n  gap: 32px;\n}\n\n.summary-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.summary-card .card-title {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.summary-card .card-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.eth-icon {\n  font-size: 14px;\n  color: #627eea;\n}\n\n.currency-icon {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.green-text {\n  color: #86efac;\n}\n\n.summary-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n\n.detail-section {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.table-container {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9fafb;\n  font-weight: 600;\n  color: #374151;\n  padding: 12px 8px;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n  white-space: nowrap;\n}\n\n.table td {\n  padding: 12px 8px;\n  border-bottom: 1px solid #e5e7eb;\n  color: #111827;\n}\n\n.table tr:hover {\n  background-color: #f9fafb;\n}\n\n.sort-icon {\n  width: 10px;\n  height: 10px;\n  margin-left: 4px;\n  cursor: pointer;\n  display: inline-block;\n  background-image: url('../../public/icon/sort-icon.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.type-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.type-badge.buy {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.type-badge.sell {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.address-cell {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.copy-icon {\n  font-size: 12px;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.copy-icon:hover {\n  color: #374151;\n}\n\n.txn-link {\n  color: #3b82f6;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.txn-link:hover {\n  color: #1d4ed8;\n}\n\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.pagination-info {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.pagination-btn {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  min-width: 40px;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background-color: #f3f4f6;\n}\n\n.pagination-btn.active {\n  background-color: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n.pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-ellipsis {\n  padding: 8px 4px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .transactions-page {\n    padding: 16px;\n  }\n  \n  .summary-section {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n  \n  .summary-cards {\n    justify-content: space-around;\n    gap: 16px;\n  }\n  \n  .summary-controls {\n    justify-content: center;\n  }\n  \n  .detail-section {\n    padding: 16px;\n  }\n  \n  .table {\n    font-size: 12px;\n  }\n  \n  .table th,\n  .table td {\n    padding: 8px 4px;\n  }\n  \n  .pagination {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .pagination-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 1024px) {\n  .summary-cards {\n    gap: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
